import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';

import {
    error,
    FORM,
    info,
    infoMsg,
    saveMsg, selectOption,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {showToastCustom} from "../../../components/toast/customToast";
import Switch from "react-bootstrap-switch";
import * as Yup from "yup";
import {useForm} from "react-hook-form";
import {showLoader} from "../../../components/loader/loader";
import Select from "react-select";
import {placeProvider} from "../../../providers/placeProvider";
import {roomTypeProvider} from "../../../providers/roomTypeProvider";
import {roomService} from "../../../jwt/_services/hotel/roomService";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

export default function RoomForm(props) {

    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);
    const [loading, setLoading] = useState(false);

    const [status, setStatus] = useState(editMode ? props.item?.status : false);
    const [isSpecial, setIsSpecial] = useState(editMode ? props.item?.isSpecial : false);

    const [placeOptions, setPlaceOptions] = useState([]);
    const [place, setPlace] = useState(editMode ? props.item?.place : null);
    const [roomTypeOptions, setRoomTypeOptions] = useState([]);
    const [roomType, setRoomType] = useState(editMode ? props.item?.roomType : null);

    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    useEffect(() => {
        setLoading(true);
        placeProvider.getOptions()
            .then(result => {
                if (result) {
                    setPlaceOptions(result);
                    if (props.item?.place) {
                        placeProvider.getItem(props.item?.place?.id)
                            .then(data => {
                                setPlace(data);
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                } else {
                    setPlaceOptions([]);
                    setLoading(false);
                }
            })
            .catch(_ => {
                setPlaceOptions([]);
                setLoading(false);
            });

        roomTypeProvider.getOptions()
            .then(result => {
                if (result) {
                    setRoomTypeOptions(result);
                    if (props.item?.roomType) {
                        roomTypeProvider.getItem(props.item?.roomType?.id)
                            .then(data => {
                                setRoomType(data);
                                setLoading(false);
                            });
                    } else {
                        setLoading(false);
                    }
                } else {
                    setRoomTypeOptions([]);
                    setLoading(false);
                }
            })
            .catch(_ => {
                setRoomTypeOptions([]);
                setLoading(false);
            });
    }, []);

    const {register, handleSubmit, reset} = useForm({
        defaultValues: {
            id: savedData?.id,
            uid: savedData?.uid,

            level: savedData?.level,
            number: savedData?.number,
        }
    });


    const onSubmit = (data, _) => {
        if (place === null) {
            return showToastCustom(error, selectOption);
        }
        setLoading(true);
        let dataRequest = {
            uid: data.uid,

            status: status,
            isSpecial: isSpecial,

            level: data.level,
            number: data.number,

            place: { id : place.id }
        };

        if (roomType !== undefined && roomType !== null) {
            dataRequest.roomType = { id : roomType.id }
        }

        if (!editMode) {
            //Save
            return roomService.saveItem(dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, saveMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        } else {
            //Update
            let id = savedData.id;
            delete savedData.id;
            if (JSON.stringify(savedData) === JSON.stringify(dataRequest)) {
                return showToastCustom(info, infoMsg);
            }

            dataRequest = { ...dataRequest, id }

            return roomService.updateItem(id, dataRequest)
                .then(resultData => {
                    setResult(resultData);
                    showToastCustom(success, updateMsg);
                })
                .catch(errorMessage => {
                    setLoading(false);
                    showToastCustom(error, errorMessage);
                });
        }
    };


    const onStatusChange = () => {
        setStatus(!status);
    }

    const onIsSpecialChange = () => {
        setIsSpecial(!isSpecial);
    }

    const onPlaceChange = (value) => {
        setPlace(value);
    }

    const onRoomTypeChange = (value) => {
        setRoomType(value);
    }

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setPlace(null);
        setRoomType(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
    }

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }

    return (
        <Card>
            {loading ? showLoader() : null}
            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={handleSubmit(onSubmit)}>
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>ID</Label>
                                <Input type="id" name="id" id="id"
                                       disabled
                                       value={editMode ? savedData?.id : ''}
                                />
                            </FormGroup>
                        </Col>
                        <Col md="6">
                            <FormGroup>
                                <FormGroup>
                                    <Label>UID Firebase</Label>
                                    <Input type="id" name="uid" id="uid"
                                           disabled
                                           value={editMode ? savedData?.uid : ''}
                                    />
                                </FormGroup>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="place">Lugar o edificio</Label>
                                <Select name="place"
                                        value={place}
                                        options={placeOptions}
                                        placeholder="Selecciona una opción"
                                        isDisabled={disableInputs}
                                        isSearchable={true}
                                        isClearable={true}
                                        ref={register}
                                        onChange={onPlaceChange}/>
                            </FormGroup>
                        </Col>
                        <Col md="4">
                            <FormGroup>
                                <Label htmlFor="roomType">Tipo de cuarto</Label>
                                <Select name="roomType"
                                        value={roomType}
                                        options={roomTypeOptions}
                                        placeholder="Selecciona una opción"
                                        isDisabled={disableInputs}
                                        isSearchable={true}
                                        isClearable={true}
                                        ref={register}
                                        onChange={onRoomTypeChange}/>
                            </FormGroup>
                        </Col>
                    </Row>
                    <Row>
                        <Col md="3">
                            <FormGroup>
                                <Label>Nivel </Label>
                                <Input type="number" name="level"
                                       placeholder="Codigo"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>
                        <Col md="3">
                            <FormGroup>
                                <Label>Numero de cuarto</Label>
                                <Input type="text" name="number"
                                       placeholder="Ingrese numero de cuarto"
                                       innerRef={register}
                                       disabled={disableInputs}/>
                            </FormGroup>
                        </Col>

                        <Col md="2">
                            <FormGroup>
                                <Label>Es especial</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={isSpecial}
                                        disabled={disableInputs}
                                        onChange={onIsSpecialChange}
                                />
                            </FormGroup>
                        </Col>

                        <Col md="2">
                            <FormGroup>
                                <Label>Activo</Label>
                                <br/>
                                <Switch animate={true} offText={"No"} onText={"Si"}
                                        value={status}
                                        disabled={disableInputs}
                                        onChange={onStatusChange}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => {
                                        resetForm()
                                    }}/>
                                    <ButtonEdit onClick={() => {
                                        beginEdit()
                                    }}/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={setForm}/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}